import { render, staticRenderFns } from "./AddDistrictPage.vue?vue&type=template&id=1469ed83&"
import script from "./AddDistrictPage.vue?vue&type=script&lang=js&"
export * from "./AddDistrictPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports